import moment from 'moment';
import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
	fallbackLng: 'en',
	debug: true,
	supportedLngs: ['en', 'fr', 'it', 'es', 'ca', 'de', 'nl', 'hu', 'sv', 'no', 'zh-CN', 'pt', 'pt-BR', 'ru', 'uk', 'tr', 'da'],
	interpolation: {
		escapeValue: false, // not needed for react!!
	},
	joinArrays: '\n',
	backend: {
		loadPath: `https://facilitatrip-staging-picture.s3.eu-west-3.amazonaws.com/translation/{{lng}}.json`
	},
	// backend: {
	// 	loadPath: () => {
	// 		return 'https://ft-translations.s3.eu-west-3.amazonaws.com/translation/{{lng}}.json';
	// 	},
	//
	// 	parse: function (data) {
	// 		return JSON.parse(data);
	// 	},
	// 	// loadPath: "/Server/Locales/{{lng}}.json"
	// },
	react: {
		useSuspense: true
	},
	detection: {
		order: ["localStorage", "navigator"],
		lookupQuerystring: "lng",
		lookupLocalStorage: window.location.pathname.includes('provider-booking/provider/') ||
		window.location.pathname.includes('provider-quotation/provider/') ?
			'18nextProviderLng' :
			"i18nextLng",
		caches: ["localStorage"]
	}
}, () => {
	moment.locale(i18n.language);
});

export default i18n;